import { PartFinderReport } from '@/api/generatedApi';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const PART_FINDER_REPORT_SUGGESTIONS_QUERY_KEY = 'partFinderReportSuggestions';

const MIN_SEARCH_LENGTH = 1;
const SUGGESTION_LIMIT = 8;
const DEBOUNCE_MS = 300;

export const usePartFinderReportSuggestions = (searchTerm: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const debouncedTerm = useDebouncedValue(searchTerm.trim(), DEBOUNCE_MS);

  const enabled = !!tenantId && debouncedTerm.length >= MIN_SEARCH_LENGTH;

  const { data, isFetching } = useQuery<PartFinderReport[], AxiosApiError>({
    queryKey: [PART_FINDER_REPORT_SUGGESTIONS_QUERY_KEY, tenantId, debouncedTerm],
    queryFn: async () => {
      const response = await api.tenants.listPartFinderReports(
        tenantId,
        1,
        SUGGESTION_LIMIT,
        undefined,
        false,
        debouncedTerm
      );
      return response.data.partFinderReports;
    },
    enabled,
  });

  return { suggestions: enabled ? (data ?? []) : [], isFetching };
};
